import { useRef } from 'react';
import isEqual from 'fast-deep-equal';

/**
 * Preserve the same reference for deeply-equal values.
 * Prevents effect/callback dependency arrays from thrashing when
 * callers recreate arrays/objects each render.
 */
export const useStableValue = (value) => {
  const ref = useRef(value);

  if (!isEqual(ref.current, value)) {
    ref.current = value;
  }

  return ref.current;
};

/**
 * Convenience helper for arrays – sorts (optionally) before stabilizing.
 */
export const useStableArray = (arrayValue, { sort = false } = {}) => {
  const normalized = Array.isArray(arrayValue)
    ? sort
      ? [...arrayValue].sort()
      : [...arrayValue]
    : arrayValue;
  return useStableValue(normalized);
};



